/* U7 Lab Results — live COA list pulled from the U7 COA master Google Sheet.
   The Liquid-rendered groups stay in place as the no-JS / fetch-failure
   fallback; on a successful fetch this rebuilds the list from sheet data.
   Sheet values are inserted via textContent only (never innerHTML). */
(function () {
  var root = document.querySelector('[data-u7-lab]');
  if (!root || !root.getAttribute('data-sheet')) return;

  var CTA = root.getAttribute('data-cta') || 'VIEW COA';
  var PENDING = root.getAttribute('data-pending') || 'COMING SOON';
  var EXPAND_FIRST = root.getAttribute('data-expand-first') === 'true';

  /* "PREFIX::LABEL" entries, one per line; longest prefix wins */
  var groupMap = (root.getAttribute('data-groups') || '')
    .split(/\r?\n/)
    .map(function (l) {
      var p = l.split('::');
      return p.length >= 2 ? { prefix: p[0].trim().toUpperCase(), label: p.slice(1).join('::').trim() } : null;
    })
    .filter(Boolean)
    .sort(function (a, b) { return b.prefix.length - a.prefix.length; });

  function parseCSV(text) {
    var rows = [], row = [], field = '', inQ = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (inQ) {
        if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else { inQ = false; } }
        else { field += c; }
      } else if (c === '"') { inQ = true; }
      else if (c === ',') { row.push(field); field = ''; }
      else if (c === '\n' || c === '\r') {
        if (c === '\r' && text[i + 1] === '\n') i++;
        row.push(field); field = ''; rows.push(row); row = [];
      } else { field += c; }
    }
    if (field !== '' || row.length) { row.push(field); rows.push(row); }
    return rows;
  }

  fetch(root.getAttribute('data-sheet'))
    .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
    .then(function (text) {
      var rows = parseCSV(text);
      if (rows.length < 2) return;
      var head = rows.shift().map(function (h) { return h.trim().toUpperCase(); });
      var iSku = head.indexOf('SKU');
      var iDesc = head.indexOf('DESCRIPTION');
      var iType = head.indexOf('PRODUCT TYPE');
      var iSample = head.indexOf('SAMPLE ID');
      var iDate = head.indexOf('REPORT CREATED');
      var iLink = head.indexOf('COA LINK');
      var iBatch = head.indexOf('BATCH ID');
      if (iSku < 0 || iDesc < 0) return; /* sheet layout changed — keep fallback */

      var cell = function (r, i) { return i >= 0 && r[i] ? r[i].trim() : ''; };
      var order = [];
      var groups = {};
      rows.forEach(function (r) {
        var sku = cell(r, iSku).toUpperCase();
        var desc = cell(r, iDesc);
        if (!sku && !desc) return; /* spacer row */
        var label = '';
        for (var g = 0; g < groupMap.length; g++) {
          if (sku.indexOf(groupMap[g].prefix) === 0) { label = groupMap[g].label; break; }
        }
        /* no prefix match — fall back to the sheet's PRODUCT TYPE column so a
           new SKU family lands in its own category instead of OTHER PRODUCTS */
        if (!label) label = cell(r, iType).toUpperCase() || 'OTHER PRODUCTS';
        /* flavor = trailing " - " segment of the description */
        var parts = desc.split(' - ');
        var name = (parts.length > 1 ? parts[parts.length - 1] : desc).trim() || sku;
        var link = cell(r, iLink);
        if (link && !/^https?:\/\//i.test(link)) link = '';
        if (!groups[label]) { groups[label] = []; order.push(label); }
        groups[label].push({
          name: name,
          sku: cell(r, iSku),
          sample: cell(r, iSample) || cell(r, iBatch),
          date: cell(r, iDate),
          link: link
        });
      });
      if (!order.length) return;

      var list = document.createElement('div');
      order.forEach(function (label, gi) {
        var details = document.createElement('details');
        details.className = 'u7-lab__group';
        if (EXPAND_FIRST && gi === 0) details.open = true;

        var summary = document.createElement('summary');
        summary.className = 'u7-lab__band';
        var bandText = document.createElement('span');
        bandText.textContent = label;
        var caret = document.createElement('span');
        caret.className = 'u7-lab__caret';
        caret.setAttribute('aria-hidden', 'true');
        summary.appendChild(bandText);
        summary.appendChild(caret);
        details.appendChild(summary);

        var ul = document.createElement('ul');
        ul.className = 'u7-lab__rows';
        ul.setAttribute('role', 'list');
        groups[label].forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'u7-lab__row';
          var info = document.createElement('div');
          info.className = 'u7-lab__row-info';
          var flavor = document.createElement('span');
          flavor.className = 'u7-lab__flavor';
          flavor.textContent = item.name;
          info.appendChild(flavor);
          var metaBits = [];
          if (item.sku) metaBits.push('SKU ' + item.sku);
          if (item.sample) metaBits.push('Sample ' + item.sample);
          if (item.date) metaBits.push(item.date);
          if (metaBits.length) {
            var meta = document.createElement('span');
            meta.className = 'u7-lab__meta';
            meta.textContent = metaBits.join(' • ');
            info.appendChild(meta);
          }
          li.appendChild(info);
          if (item.link) {
            var a = document.createElement('a');
            a.className = 'u7-btn u7-btn--rect u7-lab__cta';
            a.href = item.link;
            a.target = '_blank';
            a.rel = 'noopener';
            a.textContent = CTA;
            var sr = document.createElement('span');
            sr.className = 'visually-hidden';
            sr.textContent = ' — ' + item.name + ' (opens in new tab)';
            a.appendChild(sr);
            li.appendChild(a);
          } else {
            var chip = document.createElement('span');
            chip.className = 'u7-lab__pending';
            chip.textContent = PENDING;
            li.appendChild(chip);
          }
          ul.appendChild(li);
        });
        details.appendChild(ul);
        list.appendChild(details);
      });

      root.innerHTML = '';
      while (list.firstChild) root.appendChild(list.firstChild);
      root.setAttribute('data-u7-lab-live', 'true');
    })
    .catch(function () { /* fetch/parsing failed — the Liquid fallback stays */ });
})();
